<template>
  <Alert
    v-if="showScoutNotification"
    in-page
    data-testid="scout-warning"
    type="warning"
    text="Your Scout recommendation does not match your current school cap status"
  >
    <template slot="optional">
      <div>
        <p>You can modify your cap status in school settings</p>
        <AppSettingsModal
          v-model="showSettings"
          :cog="false"
        />
      </div>
      <v-btn
        icon
        class="scout-dismiss-button"
        @click="dismiss"
        aria-label="dismiss"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </template>

  </Alert>
</template>

<script>
import { Alert } from '@/components/application/Alert.vue'

const ACK_SESSION_KEY = 'si.scout'

export default {
  name: 'ScoutNotification',
  components: { Alert },
  data() {
    return {
      dataWarningAcknowledged: localStorage.getItem(ACK_SESSION_KEY),
      showSettings: false
    }
  },
  computed: {
    userID() {
      return this.$store.getters.userID
    },
    warningAcknowledged: {
      get() {
        return this.dataWarningAcknowledged
      },
      set() {

      }
    },
    showScoutNotification() {
      if (this.warningAcknowledged) {
        return false;
      }
      return true
    },
  },
  methods: {
    dismiss() {
      this.warningAcknowledged = true
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-alert__content {
  button {
    border: none;
    &:focus {
      border: 3px solid $ads-navy;
    }
  }
  .settings-link {
    color: $color-warning-dark;
  }
  .scout-dismiss-button {
    border: none;
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
